import React from 'react';
import { AsyncCheckboxSelectEdit } from '@atlassian/jira-issue-field-checkbox-select/src/async.tsx';
import { mapDataToOptions } from '@atlassian/jira-issue-field-checkbox-select/src/ui/edit/utils.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { FieldLoader } from '../../common/ui/field-loader/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateCheckboxField } from '../../common/utils/validators/index.tsx';
import type { Props, CheckboxSelectFieldConfig, FieldValue } from './types.tsx';

const CheckboxSelectField = (props: Props) => {
	const {
		autoFocus,
		width,
		fieldProps: { value, onChange, ...fieldProps },
		error,
		allowedValues,
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		isReadOnly = false,
	} = props;
	const options = mapDataToOptions(allowedValues);
	return (
		<FieldContainer width={width}>
			<Placeholder name="async-checkbox-select-edit" fallback={<FieldLoader />}>
				<AsyncCheckboxSelectEdit
					{...fieldProps}
					options={options}
					value={value}
					onChange={onChange}
					isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
					autoFocus={autoFocus}
					isInvalid={Boolean(error)}
					onCloseMenuOnScroll={onCloseMenuOnScroll}
					isDisabled={isReadOnly}
				/>
			</Placeholder>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateCheckboxField,
	transformDefaultValue: mapDataToOptions,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CheckboxSelectFieldConfig, Options>, any>'.
})<CheckboxSelectFieldConfig, FieldValue>(CheckboxSelectField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateCheckboxSelectField } from './utils';
